import React from 'react'

function Customsoft() {
  return (
    <div>
      {/* Hero Start */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5">
            <div className="col-lg-6 align-self-center text-center text-lg-start mb-lg-5">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Customized Software Solutions</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="#">Home</a></li>
                  <li className="breadcrumb-item"><a className="text-white" href="#">Services</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Customized Software</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Bluevipers Technology specializes in building custom software solutions tailored to your unique business requirements.
                From workflow automation to advanced management systems, we ensure high efficiency and seamless integration with your operations.
              </p>
            </div>
            <div className="col-lg-6 align-self-end text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Customized Software" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>
      {/* Hero End */}

      {/* Feature Start */}
      <div className="container-fluid bg-dark feature pt-5">
        <div className="container pt-5">
          <div className="row g-5">
            <div className="col-lg-12 align-self-center mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Customized Software</div>
              <h1 className="text-white mb-4">Tailored Solutions for Every Industry</h1>
              <p className="text-light mb-4">
                Our customized software solutions are designed to fit perfectly with your business model.
                Whether you need a management system for a hospital, ERP solutions for manufacturing, or specialized tools for retail,
                we create software that meets your exact needs.
              </p>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Fully Tailored to Your Business Requirements</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Easy Integration with Existing Systems</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Scalable Solutions for Future Growth</span>
              </div>

            </div>

          </div>
        </div>
      </div>
      {/* Feature End */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center">
          <h2 className="text-white mb-4">Get in Touch with Bluevipers Technology</h2>
          <p className="text-white-50 mb-2">
            Call us at <strong>+91 8459432930</strong>
          </p>
          <p className="text-white-50 mb-4">
            Email: <strong>blueviperstechnology@gmail.com</strong>
          </p>
          <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
        </div>
      </div>

      {/* Newsletter End */}
    </div>
  )
}

export default Customsoft
